export default function editHousingCorporationHiddenState(
  {patch}: any,
  {cid, hidden}: {cid: number; hidden: boolean},
): Promise<{}> {
  return patch(
    `/housing-corporations/hidden`,
    {hidden, cid},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationHiddenState.tsx